import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { CategoriaPlanoConta } from '../domain/categoria-plano-conta.model';

export class CategoriaPlanoContaSerializer extends DomainSerializer<CategoriaPlanoConta> {}
